import { getAudio } from "@/audio";
import { humFlags } from "@/humSurprise";

export const playCrashRain = (secs = 5.5) => {
  if (humFlags.quiet) return;
  const { ctx, out } = getAudio();
  const t = ctx.currentTime;
  const buf = ctx.createBuffer(1, ctx.sampleRate * secs, ctx.sampleRate);
  const d = buf.getChannelData(0);
  for (let i = 0; i < d.length; i++) d[i] = (Math.random() * 2 - 1) * (Math.random() < 0.0015 ? 3 : 0.6);
  const src = ctx.createBufferSource();
  src.buffer = buf;
  const hp = ctx.createBiquadFilter();
  hp.type = "highpass";
  hp.frequency.value = 900;
  const lp = ctx.createBiquadFilter();
  lp.type = "lowpass";
  lp.frequency.value = 5200;
  const g = ctx.createGain();
  g.gain.setValueAtTime(0.0001, t);
  g.gain.linearRampToValueAtTime(0.09, t + 0.9);
  g.gain.setValueAtTime(0.09, t + secs - 1.8);
  g.gain.linearRampToValueAtTime(0.0001, t + secs);
  src.connect(hp).connect(lp).connect(g).connect(out);
  src.start(t + 0.3);
  src.stop(t + secs + 0.3);
  window.__crashRainSounds = (window.__crashRainSounds || 0) + 1;
};
